import React from "react";
import { useTranslation } from "react-i18next";
import { Panel } from "primereact/panel";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { ICadastralLocalizaTelefone, ITelefoneItem } from "../../../interface/CadastralLocalizaTelefone";

export default function CadastralLocalizaTelefone({
  cadastralLocalizaTelefone,
}: {
  cadastralLocalizaTelefone: ICadastralLocalizaTelefone | null | undefined;
}) {
  const { t } = useTranslation();

  const titular = cadastralLocalizaTelefone?.TITULAR_DO_TELEFONE;
  const telefones = titular?.TELEFONES;

  const hasTelephones = Array.isArray(telefones) && telefones.length > 0;

  const formatarTelefone = (rowData: ITelefoneItem) => {
    const ddd = rowData.DDD ? `(${rowData.DDD}) ` : "";
    const numero = rowData.NUM_TELEFONE || rowData.NUMERO || "";
    return `${ddd}${numero}`;
  };

  const formatarDocumento = (rowData: ITelefoneItem) => {
    const doc = rowData.DOCUMENTO || "";
    if (doc.length === 11) {
      return doc.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    } else if (doc.length === 14) {
      return doc.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
    }
    return doc;
  };

  const formatarEndereco = (rowData: ITelefoneItem) => {
    const parts = [
      rowData.ENDERECO,
      rowData.NUMERO,
      rowData.COMPLEMENTO,
      rowData.BAIRRO,
      rowData.CIDADE,
      rowData.UF,
      rowData.CEP ? `CEP: ${rowData.CEP}` : "",
    ].filter((p) => p && p.trim() !== "");
    return parts.join(", ");
  };

  return (
    <Panel header="Localização de Telefone" style={{ width: "98%" }}>
      {!hasTelephones ? (
        <div
          className="p-3 text-center border-round font-bold"
          style={{
            backgroundColor: "#fff3cd",
            color: "#664d03",
            border: "1px solid #ffe69c",
          }}
        >
          TELEFONE NAO ENCONTRADO NA BASE
        </div>
      ) : (
        <DataTable
          size="small"
          value={telefones}
          tableStyle={{ minWidth: "50rem" }}
        >
          <Column field="NOME" header={t("nome")} sortable></Column>
          <Column body={formatarDocumento} header={t("documento")}></Column>
          <Column body={formatarTelefone} header={t("fone")} ></Column>
          <Column body={formatarEndereco} header={t("endereco")}></Column>
        </DataTable>
      )}
    </Panel>
  );
}
